function jsonToQueryString(json) {
    let string = '?' +
        Object.keys(json).map(function (key, index) {
            if (json[key] !== null) {
                return (index !== 0 ? '&' : '') + encodeURIComponent(key) + '=' +
                encodeURIComponent(json[key]);
            }
            return null;
        }).join('');
    return string;
}

export {
    jsonToQueryString,
};
